"use client"
import { useLanguage } from "../../contexts/LanguageContext"
import { Icons } from "../../components/Icons"
import ToolSwitcher from "./src/app/toolswitcher"
import Types from "./src/tools/types"
import Trainer from "./src/tools/trainer"
import Multi from "./src/tools/multi"
import Cards from "./src/tools/cards"
import { useState } from "react"

const AppContent = () => {
  const [currentTool, setCurrentTool] = useState("main")

  const switchTool = (toolName) => {
    setCurrentTool(toolName || "main")
  }

  const renderCurrentTool = () => {
    switch (currentTool) {
      case "main":
        return <ToolSwitcher onSwitch={switchTool} />
      case "types":
        return <Types onSwitch={switchTool} />
      case "trainer":
        return <Trainer onExit={switchTool} />
      case "multi":
        return <Multi onExit={switchTool} />
      case "cards":
        return <Cards onExit={switchTool} />
      default:
        return <ToolSwitcher onSwitch={switchTool} />
    }
  }

  return <div>{renderCurrentTool()}</div>
}


const Mental = ({ onClose }) => {
  const { t } = useLanguage()

  return (
    <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-2">
            {t("trainings.mental")}
            {onClose && (
              <button onClick={() => onClose()} className="btn btn-secondary btn-small">
                <Icons.Close className="w-4 h-4" />
              </button>
            )}
          </h1>
          {/* <p className="text-lg text-gray-600">{t("trainings.mental.description")}</p> */}
        </div>
      </div>
      <div>
        <AppContent />
      </div>
    </div>
  )
}

export default Mental
